export class DeleteProjectByIdQuery {
  query = ({ projectId, cb } : { projectId: number, cb?: () => void }) => ({
    url: `/projects/${projectId}`,
    method: 'DELETE'
  })
}